// extracted by mini-css-extract-plugin
export default {"NoticeView":"NoticeView_NoticeView__nUmzS","Header":"NoticeView_Header__JDaFV","Body":"NoticeView_Body__Yba4I"};